import { Skeleton as MuiSkeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { SkeletonTextProps, SKELETON_ANIMATION } from '../Skeleton.types';
import { getSkeletonBackgroundColor, getSkeletonBorderRadius } from '../styleUtils';

const DEFAULT_HEIGHT = 16;
const DEFAULT_WIDTH = '100%';

export const SkeletonText = ({
    width = DEFAULT_WIDTH,
    height = DEFAULT_HEIGHT,
    sx,
}: SkeletonTextProps) => {
    const theme = useTheme();

    return (
        <MuiSkeleton
            variant="rounded"
            width={width}
            height={height}
            animation={SKELETON_ANIMATION}
            sx={{
                backgroundColor: getSkeletonBackgroundColor(theme),
                borderRadius: getSkeletonBorderRadius(theme),
                ...sx,
            }}
        />
    );
};
